/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { decrementDate, incrementDate } from '@shared/utils';
import { initialState, ToursState } from '@tours/store/tours.state';
import * as TourActions from './tours.actions';

export function toursReducer(state = initialState, action: TourActions.TourActions): ToursState {
  switch (action.type) {
    case TourActions.LOAD_TOURS:
    case TourActions.LOAD_TOUR:
    case TourActions.PERSIST:
    case TourActions.TOUR_WORKFLOW_ACTION:
    case TourActions.LOAD_LOCATIONS:
      return {
        ...state,
        hasError: false,
        actionPending: true
      };
    case TourActions.LOAD_TOURS_SUCCESS:
      return {
        ...state,
        tours: action.tours,
        actionPending: false
      };
    case TourActions.LOAD_TOURS_FAILURE:
    case TourActions.LOAD_TOUR_FAILURE:
    case TourActions.PERSIST_FAILURE:
    case TourActions.TOUR_WORKFLOW_ACTION_FAILURE:
    case TourActions.LOAD_LOCATIONS_FAILURE:
      return {
        ...state,
        hasError: true,
        actionPending: false
      };
    case TourActions.TOUR_WORKFLOW_ACTION_ABORTED:
      return {
        ...state,
        hasError: false,
        actionPending: false
      };
    case TourActions.TOGGLE_SIDEBAR:
      return {
        ...state,
        isSidebarExpanded: !state.isSidebarExpanded
      };
    case TourActions.SET_CURRENT_DATE:
      return {
        ...state,
        currentDate: action.date
      };
    case TourActions.INCREMENT_CURRENT_DATE:
      return {
        ...state,
        currentDate: incrementDate(state.currentDate)
      };
    case TourActions.DECREMENT_CURRENT_DATE:
      return {
        ...state,
        currentDate: decrementDate(state.currentDate)
      };
    case TourActions.LOAD_TOUR_SUCCESS:
    case TourActions.PERSIST_SUCCESS:
      return {
        ...state,
        currentTour: action.tour,
        hasError: false,
        actionPending: false
      };
    case TourActions.INIT:
    case TourActions.LOAD_TOUR_APPOINTMENT_CLASSES_SUCCESS:
      return {
        ...state,
        tourAppointmentClasses: action.tourAppointmentClasses
      };
    case TourActions.LOAD_CURRENT_ABSENCES_SUCCESS:
      return {
        ...state,
        currentAbsences: action.payload
      };
    case TourActions.LOAD_ABSENCE_SUMMARY_SUCCESS:
      return {
        ...state,
        absenceSummary: action.payload
      };
    case TourActions.LOAD_ABSENCE_SUMMARY_FAILURE:
      return {
        ...state,
        absenceSummary: []
      };
    case TourActions.LOAD_LOCATIONS_SUCCESS:
      return {
        ...state,
        locations: action.locations,
        currentLocation: action.locations[0] === undefined ? null : action.locations[0],
      };
    case TourActions.SET_FILTER:
      return {
        ...state,
        currentTourClass: action.tourClass
      };
    case TourActions.LOAD_MONTHLY_STATISTICS_SUCCESS:
      return {
        ...state,
        monthlyStatistics: action.statistics
      };
    case TourActions.SET_CURRENT_LOCATION:
      return {
        ...state,
        currentLocation: action.location
      };
    case TourActions.SET_CURRENT_VIEW:
      return {
        ...state,
        currentView: action.currentView
      };
    case TourActions.SET_STATE_FILTER:
      return {
        ...state,
        viewModeFilters: {
          ...state.viewModeFilters,
          [action.payload.tourViewMode]: {
            ...state.viewModeFilters[action.payload.tourViewMode],
            stateFilterValues: action.payload.stateFilterValues
          }
        }
      };
    default:
      return state;
  }
}
